module.exports = __webpack_public_path__ + "static/media/13.a7ca5d7d.png";